<template>
  <section>
    <slot/>
  </section>
</template>

<script>
export default {
  name: "Section",
  props: {}
};
</script>

<style scoped>
</style>
